import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthServerProvider, EventManager } from 'src/app/core';
import { ToastrService } from 'ngx-toastr';
import HelperUtil from 'src/app/shared/util/helper-util';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
@Injectable()
export class UploaderService {
    uploader: FileUploader;
    allowedMimeType = [];
    isErrorUpload: boolean = false;
    broadcast: string = 'no-name';
    constructor(
        private authServerProvider: AuthServerProvider,
        private toastr: ToastrService,
        private eventManager: EventManager
    ) {}
    initUploader(api, broadcast, allowedFileType?) {
        const attachedFiles = [];
        const config: any = {
            isHTML5: true,
            url: api,
            authToken: 'Bearer ' + this.authServerProvider.getToken(),
            maxFileSize: environment.MAX_FILE_SIZE,
            autoUpload: true,
            headers: [{
                name: 'clientApiKey',
                value: 'FMARKET-ANGULAR-KEY2'
            }]
        };
        if (allowedFileType) {
            config.allowedFileType = allowedFileType;
        }
        const uploader = new FileUploader(config);
        // clientApiKey: 'FMARKET-ANGULAR-KEY2',
        uploader.onWhenAddingFileFailed = (item, filter) => {
            let message = 'Error Upload';
            switch (filter.name) {
            //   case 'queueLimit':
            //     message = 'Only uploading max ' + environment.MAX_QUEUE_LIMIT + 'files';
            //     break;
              case 'fileSize':
                // tslint:disable-next-line:max-line-length
                message = 'Hình ảnh vượt quá ' + HelperUtil.formatBytes(environment.MAX_FILE_SIZE) + ' cho phéo';
                break;
              case 'fileType':
                message = 'Chỉ cho phép các loại sau: ' + (allowedFileType || []).join(', ');
                break;
              default:
                message = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
                break;
            }
            this.toastr.error(message);
        };
        uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            if (this.isErrorUpload) {
                return;
            }
            const data = JSON.parse(response);
            const imagePath = data.listFileUploaded[0] ? data.listFileUploaded[0].url : '';
            const file = data.listFileUploaded[0];
            let type = 'file';
            if (file.fileName.includes('.doc') || file.fileName.includes('.docx')) {
                type = 'word';
            } else if (file.fileName.includes('.xls') || file.fileName.includes('.xlxs')) {
                type = 'excel';
            } else if (file.fileName.includes('.pdf')) {
                type = 'pdf';
            } else if (file.fileName.includes('.jpg') || file.fileName.includes('.jpeg') || file.fileName.includes('.png') || file.fileName.includes('.gif')) {
                type = 'image';
            }
            file.type = type;
            const exist = attachedFiles.some(item => item.fileName === file.fileName);
            if (exist) {
                this.toastr.error('File đã tồn tại.');
                return;
            }
            attachedFiles.push(file);
            this.eventManager.broadcast({
                name: broadcast,
                content: {
                    file: file,
                    files: attachedFiles,
                    imagePath
                }
            });
        };
        uploader.onAfterAddingFile = (item: any) => {
            this.isErrorUpload = false;
        };
        uploader.onBeforeUploadItem = (item: any) => {
            const split = item.file.name.split('.');
            const extension = split.pop();
            const name = split.join('.') + '_' + Date.now() +  '.' + extension;
            item.file.name = name 
            this.isErrorUpload = false;
            return item;
        };
        uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.isErrorUpload = true;
            if (!response) {
                return;
            }
            const error = JSON.parse(response);
            this.toastr.error(error.detail);
        };
        return uploader;
    }
}
// List of allowedFileTypes values:

// application
// image
// video
// audio
// pdf
// compress
// doc
// xls
// ppt